import calendarIcon from 'assets/images/explore-learnings/calendar.svg'
import chatIcon from 'assets/images/explore-learnings/chat.svg'
import locationIcon from 'assets/images/explore-learnings/location.svg'
// import practitionerEmpty from 'assets/images/explore-learnings/practitioner-empty.svg'
import { generateTeamsChatLink, generateTeamsMeetingLink } from 'utils/common'

import { Skill } from './SkillTag'
import { TagGroup } from './TagGroup'
import { Tooltip } from './Tootip'

interface PractitionerCardProps {
  imageUrl?: string
  name: string
  email: string
  role: string
  location: string
  tags?: Skill[]
}

export const PractitionerCard = ({ name, email, role, location, tags }: PractitionerCardProps) => {
  return (
    <div
      className="w-[358px] p-[2px] h-[144px] rounded-2xl hover:shadow-lg transition-all font-TCCC overflow-visible 
      gradient-border-light"
    >
      <div className="p-3 flex group w-full h-full bg-white rounded-2xl">
        {/* <div className="w-[120px] mr-3">
          <img
            src={imageUrl || practitionerEmpty}
            alt={name}
            onError={e => (e.currentTarget.src = practitionerEmpty)}
            className="w-full h-full rounded-8 group-hover:h-[92px] duration-500 transition-all object-cover"
          />

          <div
            className="justify-center flex opacity-0 mt-2  group-hover:opacity-100 transition-opacity duration-500 w-full"
            onClick={e => {
              e.stopPropagation()
            }}
          >
            <div className="relative ">
              <a className="flex" href={generateTeamsChatLink(email)} target="_blank" rel="noopener noreferrer">
                <img className="w-5 cursor-pointer mr-3 peer/call" src={chatIcon} alt="Call" />
                <div className="absolute -top-[42px] -right-[60px] opacity-0 peer-hover/call:opacity-100 ease-out">
                  <Tooltip text="Open Teams chat" />
                </div>
              </a>
            </div>
            <div className="relative">
              <a className="flex" href={generateTeamsMeetingLink(email)} target="_blank" rel="noopener noreferrer">
                <img className="w-5 cursor-pointer peer/copy" src={calendarIcon} alt="Copy" />
                <div className="absolute -top-[42px] -right-[75px] opacity-0 peer-hover/copy:opacity-100">
                  <Tooltip text="Schedule meeting" />
                </div>
              </a>
            </div>
          </div>
        </div> */}
        <div className="flex flex-col w-full">
          <p className="pb-1 mb-2 font-bold border-b border-solid border-[#D7D7D7]">{name}</p>
          <p className="text-12">{role}</p>
          <p className="flex text-12 text-[#505050] my-1">
            <img src={locationIcon} className="w-4 mr-[2px]" alt="Location" /> <span>{location}</span>
          </p>
          <div className="flex justify-between mt-auto">
            <div>{tags && <TagGroup skills={tags} />}</div>
            <div className="flex self-center">
              <div className="relative">
                <a
                  className="flex"
                  href={generateTeamsChatLink(email)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => e.stopPropagation()}
                >
                  <img className="w-5 cursor-pointer mr-3 peer/call" src={chatIcon} alt="Call" />
                  <div className="absolute -top-[42px] -right-[60px] opacity-0 peer-hover/call:opacity-100 ease-out pointer-events-none">
                    <Tooltip text="Open Teams chat" />
                  </div>
                </a>
              </div>
              <div className="relative">
                <a
                  className="flex"
                  href={generateTeamsMeetingLink(email)}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => e.stopPropagation()}
                >
                  <img className="w-5 cursor-pointer peer/copy" src={calendarIcon} alt="Copy" />
                  <div className="absolute -top-[42px] -right-[75px] opacity-0 peer-hover/copy:opacity-100 pointer-events-none">
                    <Tooltip text="Schedule meeting" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
